import { TimePicker } from './time-picker.component';

export * from './time-picker.component';
export default TimePicker;

if (!customElements.get('der-tm-appointment-booking-time-picker')) {
    customElements.define('der-tm-appointment-booking-time-picker', TimePicker);
}
